import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../../Common/AdminBreadcrumb';
import Loader from '../../Common/Loader';

import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { GetUsers, DeleteUser, GetCorporate, GetParticipantFilter } from '../../../../API/admin'
import { GetTeams } from '../../../../API/auth'

import Swal from 'sweetalert2'
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from '@coreui/react'


const Users = () => {
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Users', to: '/users', active: true }
    ];

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [Users, setUsers] = useState([]);
    const [loaderStatus, setLoaderStatus] = useState(true);
    const [alluser, setAllUser] = useState([]);
    const [selectedOption, setSelectedOption] = useState('admin');
    const [selectedTeam, setSelectedTeam] = useState('');
    const [selectedGender, setSelectedGender] = useState(null);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [teams, setTeams] = useState([]);
    const [searchTerm, setSearchTerm] = useState(false);


    useEffect(() => {
        getUserAPI(selectedOption, selectedTeam, selectedGender);
        getTeamsAPI();
    }, [page]);

    const getUserAPI = async (type, team = null, gender) => {
        setLoaderStatus(true);
        let formData;
        console.log("gender", gender)
        if (type === 'all') {
            formData = {
                page: null,
                limit: null,
                team: null,
                gendder: null,
                type: type
            }
        } else {

            formData = {
                type: type,
                page: page,
                limit: limit,
                team: type === 'participant' ? team : null,
                gender: gender ? gender : null
            }
        }
        console.log("formdata", formData)
        const res = await GetUsers(formData);  // Pass page and limit to API
        if (res.status) {
            setUsers(res.data);
            setAllUser(res.data);
            setTotalRecords(res.totalRecords);  // Track total records
            setLoaderStatus(false);
        } else {
            setUsers([]);
            setAllUser([]);
            setLoaderStatus(false);
        }
    };

    let getTeamsAPI = async () => {
        let res = await GetTeams();
        setTeams(res.data)
        console.log(res.data)
    }
    const handleSearch = async (event) => {
        if (selectedOption === 'participant') {
            setSearchTerm(true);
            console.log("jherere")
            const filterUser = await GetParticipantFilter(event.target.value);
            console.log(filterUser);
            if (filterUser.data.length) {
                setUsers(filterUser.data); // Assuming filterUser has a data property

            } else {
                setUsers([]);

            }
        } else {
            console.log("else ")
            const search = event.target.value.replace(/\s+/g, ''); // Remove all spaces from the search input
            const subArr = alluser.filter(user => {
                // Concatenate fname and lname for the combined check
                const fullName = (user.fname + user.lname).toLowerCase();

                return (
                    user.fname.toLowerCase().includes(search) ||                // Check if `fname` matches
                    (user.corporate_email != null && user.corporate_email.toLowerCase().includes(search)) || // Check corporate email
                    user.email.toLowerCase().includes(search) ||                // Check personal email
                    user.lname.toLowerCase().includes(search) ||                // Check if `lname` matches
                    fullName.includes(search)                                   // Check if `fname + lname` matches
                );
            });
            console.log(subArr);
            setUsers(subArr);
        }
    };


    const handleDelete = async (urlid, role) => {
        let res = await Swal.fire({
            title: "Are you sure to delete team?",
            text: "team will be removed from tournament",
            // icon: "warning"
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonText: "Send Request",
            cancelButtonText: "Close"

        });

        if (res.isConfirmed) {
            let userID = { id: urlid };
            console.log(userID.id);
            let res = await DeleteUser(userID);
            if (res.status) {
                enqueueSnackbar("User Deleted successfully", {
                    variant: 'success', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                });
                getUserAPI(role);
            } else {
                enqueueSnackbar(res.totalRecords === 1 ? "This user is in waitlist, unable to delete" : "Cannot delete user", {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                });
                navigate('/users');
            }
        }
    };

    const handleSelectChange = (e) => {
        setSelectedOption(e.target.value);
        setPage(1)
        getUserAPI(e.target.value);
    };
    const handleTeamChange = (e) => {
        setSelectedTeam(e.target.value);
        getUserAPI('participant', e.target.value, selectedGender);
    };


    const handleGenderChange = (e) => {
        setSelectedGender(e.target.value);
        getUserAPI('participant', selectedTeam, e.target.value);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= Math.ceil(totalRecords / limit)) {
            setPage(newPage);
        }
    };
    function toTitleCase(str) {
        return str
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase());
    }
    const totalPages = Math.ceil(totalRecords / limit);

    return (
        <>
            {loaderStatus ? <Loader /> : null}
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            <CCard className="mb-4">
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h3 className="card-title mb-3">Users</h3>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg={2} md={2}>
                            <input type="search" className='form-control mb-2' placeholder="Search" name='data' onChange={handleSearch} />
                        </CCol>
                        <CCol lg={2} md={2}>
                            <select className='form-select mb-2' value={selectedOption} onChange={handleSelectChange}>
                                <option value="admin">Admin</option>
                                <option value="scorer">Scorer</option>
                                <option value="participant">Participant</option>
                                <option value="all">All</option>

                            </select>
                        </CCol>
                        <CCol lg={2} md={2}>
                            {
                                selectedOption == 'participant' ? (
                                    <>

                                        <select
                                            name='team'
                                            className='form-select mb-2'
                                            value={selectedTeam}
                                            onChange={handleTeamChange}  // Attach handleChange here
                                            required

                                        >
                                            <option value="" disabled selected>Select a Team</option>
                                            {teams.length > 0 ? (
                                                teams.map((entry, index) => (
                                                    <option key={index} value={entry.domain}>
                                                     {toTitleCase(entry.domain) }
                                                    </option>
                                                ))
                                            ) : null}
                                        </select>


                                    </>
                                ) : null
                            }
                        </CCol>
                        <CCol lg={2} md={2}>
                            {
                                selectedOption == 'participant' ? (
                                    <>

                                        <select
                                            name='team'
                                            className='form-select mb-2'
                                            value={selectedGender}
                                            onChange={handleGenderChange}  // Attach handleChange here
                                            required

                                        >
                                            <option value="" disabled selected>Select a Gender</option>

                                            <option value='male'>
                                                Male
                                            </option>
                                            <option value='female'>
                                                Female
                                            </option>
                                        </select>


                                    </>
                                ) : null
                            }
                        </CCol>
                        <CCol lg={4} md={4} className="d-md-block">
                            <Link to='/user/create'>
                                <CButton className='float-end text-white mb-2 ms-2' color="info">
                                    <i className="bi bi-plus-circle"></i> &nbsp;
                                    Add user
                                </CButton>
                            </Link>
                            <Link to={`/send-mail?role=${selectedOption}&filter=all`}>
                                <CButton className='float-end text-white ' data-btn={selectedOption} color="info">
                                    <i className="bi bi-plus-circle "></i>&nbsp;
                                    Send Mail To ALL
                                </CButton>
                            </Link>
                        </CCol>
                    </CRow><br />
                    <CRow className='custom_scroll_table_scroll'>
                        <CTable striped>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">S.NO</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Personal Email</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Team</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Role</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {Users.length === 0 ? (
                                    <CTableRow>
                                        <CTableDataCell className='text-center' colSpan="6">No data found</CTableDataCell>
                                    </CTableRow>
                                ) : (
                                    Users.map((user, index) => (
                                        <CTableRow key={index}>
                                            <CTableHeaderCell>{(page - 1) * limit + index + 1}</CTableHeaderCell>
                                            <CTableDataCell>
                                                <div style={{ minWidth: "85px", textAlign: 'center' }}>{user.fname} {user.lname} </div>
                                            </CTableDataCell>
                                            <CTableDataCell>{user.email ? user.email : 'N/A'}</CTableDataCell>
                                            <CTableDataCell>{user.role === 'participant' && user.corporate_email ?toTitleCase(user.corporate_email) : 'N/A'}</CTableDataCell>
                                            <CTableDataCell>{user.role}</CTableDataCell>
                                            <CTableDataCell>
                                                <div className='d-flex justify-content-center'>
                                                    {(() => {
                                                        // Determine the correct ID to use based on selectedOption

                                                        return (
                                                            <>
                                                                <Link to={`/user/detail?id=${selectedOption === 'all' || searchTerm ? user.id : user._id}`}>
                                                                    <CButton className='bi bi-eye-fill text-white admin_btn_space' color="primary"></CButton>
                                                                </Link>
                                                                <Link to={`/user/edit?id=${selectedOption === 'all' || searchTerm ? user.id : user._id}&&role=${user.role}`}>
                                                                    <CButton className="bi bi-pencil text-white admin_btn_space" color="warning"></CButton>
                                                                </Link>
                                                                <CButton className='bi bi-trash-fill text-white' color="danger" onClick={() => selectedOption === 'all' || searchTerm ? handleDelete(user.id, user.role) :
                                                                    handleDelete(user._id, user.role)
                                                                }></CButton>
                                                                <Link to={`/send-mail?id=${selectedOption === 'all' || searchTerm ? user.id : user._id}`}>
                                                                    <CButton className='bi bi-envelope text-white admin_btn_space' color="info"></CButton>
                                                                </Link>
                                                            </>
                                                        );
                                                    })()}
                                                </div>
                                            </CTableDataCell>
                                        </CTableRow>
                                    ))
                                )}
                            </CTableBody>
                        </CTable>
                    </CRow>

                    <CRow>
                        <div className="user_pagination">
                            <button className='btn_user_pagination' onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
                                Previous
                            </button>
                            <span className='btn_text_user_pagintion'>{page} of {totalPages}</span>
                            <button className='btn_user_pagination' onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
                                Next
                            </button>
                        </div>
                    </CRow>
                </CCardBody>
            </CCard>
        </>
    );
};


export default Users;